import { Swiper } from "swiper/react";
import { A11y, Grid, Autoplay } from "swiper";

export default function FourRowCarousel({ setSlideState, setIsEnd, sliderRef, setIsBegin, children, ...property }) {
    return (
        <div className={`flex items-center md:-mr-0 ${property.className}`}>
            <Swiper
                watchOverflow
                onSwiper={setSlideState}
                onSlideChange={(e) => {
                    setIsEnd(e.isEnd);
                    setIsBegin(e.isBeginning);
                }}
                ref={sliderRef}
                observer
                observeParents
                spaceBetween={10}
                loopFillGroupWithBlank={false}
                className="categoryCarousel"
                grid={{
                    rows: 1,
                    fill: "row",
                }}
                modules={[A11y, Grid, Autoplay]}
                breakpoints={{
                    300: {
                        spaceBetween: 10,
                        slidesPerView: 1.25,
                    },
                    500: {
                        spaceBetween: 30,
                        slidesPerView: 2,
                    },
                    1000: {
                        slidesPerView: 4.25,
                    },
                }}
            >
                {children}
            </Swiper>
        </div>
    );
}
